// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CustomTable_tableWrapper__ajbVv","table":"CustomTable_table__Nefv5","callbackRequests":"CustomTable_callbackRequests__YXmsq"};